<template>
  <div class="whole q-mt-xl ">
    <div class="title q-mb-lg">
      <h4>Choose The Plan That Works For You</h4>
    </div>
    <div class="row q-mt-lg">
      <div class="col-8">
        <h5 class="subtitle">How Many SKU'S A Month Do You Need?</h5>
        <div class="button row">
          <div>
            <button v-bind:class="{ blue: firstClick, white: !firstClick }" @click="click50" id="button1">
              1-50
            </button>
          </div>
          <div>
            <button v-bind:class="{ blue: secondClick, white: !secondClick }" @click="click100" id="button1">
              50-100
            </button>
          </div>
          <div>
            <button v-bind:class="{ blue: thirdClick, white: !thirdClick }" @click="click150" id="button1">
              100-150
            </button>
          </div>
          <div>
            <button v-bind:class="{ blue: fourthClick, white: !fourthClick }" @click="click200" id="button1">
              150-200
            </button>
          </div>
          <div>
            <button v-bind:class="{ blue: fifthClick, white: !fifthClick }" @click="click250" id="button1">
              200-250
            </button>
          </div>
          <div>
            <button v-bind:class="{ blue: sixthClick, white: !sixthClick }" @click="click250more" id="button1">
              250 +
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col rectangle"
            v-bind:class="{ rectangleclick: subscribeButton, notrectangleclick: !subscribeButton }">
            <div class="q-ml-lg q-mt-md">
              <div class="row">

                <h5 class="box-title q-mr-xl">GOLD</h5>
                <p class="real-price q-ml-lg">₹{{ goldPrice }}</p>
                <h5 class="discount-price q-ml-xl">₹{{ goldDiscountPrice }}</h5>
                <p class="q-mt-sm q-ml-sm"> only</p>
              </div>
              <p class="line text-secondary font-weight-bold">______________________________________</p>
              <div>
                <ul class="list">
                  <li>Repricing - Daily/ Weekly/monthly.</li>
                  <li>Access to Price Tracker</li>
                  <li>Access to Price Optimiser</li>
                  <li> Performance Analysis - weekly</li>
                  <li>Access to Amazon Re-Pricer </li>
                  <li>Competitor Price Tracking and updates - Daily</li>
                  <li>Advertisement optimization</li>
                  <li>Key word suggestion</li>
                  <li> Brand Page Creation</li>
                  <li>One time listing help (A+ Content) </li>
                </ul>
              </div>
              <div class="button-sub q-mt-md"><q-btn class="subscribe-gold" @click="goldClick"
                  v-bind:class="{ subscribebutton: subscribeButton, notsubscribebutton: !subscribeButton }">Subscribe</q-btn>
              </div>
              <!-- <div class="button-sub q-mt-md" v-if="(sixMonths == true)"><q-btn class="subscribe-gold" @click="goldClick1"  v-bind:class="{subscribebutton: subscribeButton1, notsubscribebutton: !subscribeButton1 }">Subscribe</q-btn></div>
             <div class="button-sub q-mt-md" v-if="(twelveMonths == true)"><q-btn class="subscribe-gold" @click="goldClick2"  v-bind:class="{subscribebutton: subscribeButton2, notsubscribebutton: !subscribeButton2 }">Subscribe</q-btn></div> -->
            </div>
          </div>
          <div class="col q-ml-lg q-mr-xl rectangle"
            v-bind:class="{ rectangleclick: !subscribeButton, notrectangleclick: subscribeButton }"
            v-if="threeMonths == false">
            <div class="q-ml-lg q-mt-md">
              <div class="row">

                <h5 class="box-title q-mr-xl">SILVER</h5>
                <p class="real-price q-ml-lg">₹{{ silverPrice }}</p>
                <h5 class="discount-price q-ml-xl">₹{{ silverDiscountPrice }}</h5>
                <p class="q-mt-sm q-ml-sm"> only</p>
              </div>
              <p class="line text-secondary font-weight-bold">______________________________________</p>
              <div>
                <ul class="list">
                  <li>Repricing - Daily/ Weekly/monthly.</li>
                  <li>Access to Price Tracker</li>
                  <li>Access to Price Optimiser</li>
                  <li> Performance Analysis - weekly</li>
                  <li>Access to Amazon Re-Pricer </li>
                  <li>Competitor Price Tracking and updates - Daily</li>
                </ul>
                <ul class="list1">
                  <li class="point">Advertisement optimization</li>
                  <li class="point">Key word suggestion</li>
                  <li class="point"> Brand Page Creation</li>
                  <li class="point">One time listing help (A+ Content) </li>
                </ul>
              </div>
              <div class="button-sub"><q-btn class="subscribe-silver" @click="silverClick"
                  v-bind:class="{ subscribebutton: !subscribeButton, notsubscribebutton: subscribeButton }">Subscribe</q-btn>
              </div>
              <!-- <div class="button-sub" v-if="twelveMonths == true"><q-btn class="subscribe-silver" @click="silverClick1"  v-bind:class="{subscribebutton: subscribeButton4, notsubscribebutton: !subscribeButton4 }">Subscribe</q-btn></div> -->
            </div>
          </div>
          <div class="col q-ml-lg q-mr-xl rectangle2" v-if="threeMonths == true">
            <div>
              <div class="row q-mt-xl" style="justify-content:center;align-items: center;display: flex;">

                <h5 class="box-title">SILVER</h5>
              </div>
              <p class="line1 text-secondary font-weight-bold  ">______________________________________</p>
              <div class="unavailable">
                <div class="q-ml-lg q-mr-lg">
                  <p>NOT AVAILABLE UNDER ONE MONTH PLAN, PLEASE SELECT 6 MONTH OR LONGER PLAN TO AVAIL OF THIS</p>
                </div>

              </div>
              <div class="button-sub"><q-btn class="subscribe-silver1">Subscribe</q-btn></div>

            </div>
          </div>
        </div>
      </div>
      <div class="col q-ml-xl">
        <div class="button row ">
          <div>
            <button v-bind:class="{ blue: threeMonths, white: !threeMonths }" @click="threeMonths1" id="button2">
              3 Months
            </button>
          </div>
          <div>
            <button v-bind:class="{ blue: sixMonths, white: !sixMonths }" @click="sixMonths1" id="button2">
              6 Months
            </button>
          </div>
          <div>
            <button v-bind:class="{ blue: twelveMonths, white: !twelveMonths }" @click="twelveMonths1" id="button2">
              12 Months
            </button>
          </div>
        </div>
        <div class="box">
          <h6 class="your-order">YOUR ORDER</h6>
          <div class="q-mt-sm">
            <label for="code" style="color:#102689">Enter your Coupon code</label>
          </div>
          <div class="coupon_input  row ">
            <input class="col-7" type="text" id="coupon_code" name="code" v-model="code">
            <q-btn class="validate col-4" @click="validate">Validate</q-btn>
            <font-awesome-icon class="tick" v-if="valid == true" icon="fa-solid fa-circle-check" />

            <!-- <span >&#10003;</span> -->

          </div>
          <p class="q-mt-sm" style="color:red;font-size:12PX" v-if="notvalid">The Coupon code you entered is not valid.
          </p>
          <p class="q-mt-sm" style="color:red;font-size:12PX" v-if="expired">The Coupon code you entered is expired.</p>
          <div class="product-total row  q-mt-md">
            <div class="col-9">
              <p>PRODUCT</p>
            </div>
            <div>
              <p>TOTAL</p>
            </div>
          </div>
          <p class="line text-secondary font-weight-bold">_______________________________________________</p>
          <div class="row">
            <div class="data col-9 ">
              <p>{{ category }} - {{ duration }} Months + 1 Month Free</p>
            </div>
            <div>
              <p>{{ price }} Rs</p>
            </div>
          </div>
          <p class="line text-secondary font-weight-bold">_______________________________________________ <br><span
              STYLE="color:RED;font-size:12px">* If not happy after a month, money will be refunded</span></p>
          <div class="data row">
            <!-- <p>No.of sku's</p>
              <p>5000</p> -->
            <div class="col-9">
              <p>No.of sku's
                <!-- <span class=" q-ml-md">({{sku}})</span>  -->
              </p>
            </div>
            <div>
              <!-- <p>{{skusPrice}} Rs</p> -->
              <p>{{ sku }}</p>
            </div>
            <p class="line text-secondary font-weight-bold">_______________________________________________</p>
          </div>
          <div class="data row">
            <!-- <p>No.of sku's</p>
              <p>5000</p> -->
            <div class="col-9">
              <p>GST</p>
            </div>
            <div>
              <p>0 Rs</p>
            </div>
            <p class="line text-secondary font-weight-bold">_______________________________________________</p>
          </div>
          <div class="data row">
            <!-- <p>No.of sku's</p>
              <p>5000</p> -->
            <div class="col-9" style="color:red">
              <p>Discount </p>
            </div>
            <div style="color:red">
              <p>- {{ discount }} %</p>
            </div>
            <p class="line text-secondary font-weight-bold">_______________________________________________</p>
          </div>
        </div>
        <div class="row product-total ">
          <div class="col-9">
            <p>TOTAL</p>
          </div>
          <div>
            <p>₹{{ ((price + skusPrice) - (price + skusPrice) * discount / 100) }}</p>
          </div>
        </div>
        <div>
          <p class="terms"> <span><q-checkbox v-model="val" style="height:7px;font-size: 13px;" /></span>I have read and
            agree to the website terms and conditions</p>
          <p style="margin-top:-10px;font-size:13px;text-align: justify;">Your personal data will be used to process your
            order, support your experience throughout this website, and for other purposes described in our <a
              href="/PrivacyPolicy" class="privacy">privacy policy.</a> </p>
          <q-btn class="place-order" @click="placeOrder">Place Order</q-btn>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
import PricingCard from "../utilities/Components/Card/pricingCards";
export default {
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      // price: {
      //   basic: 1,
      //   pro: 19,
      //   premium: 29,
      //   details:[],
      // },
      user_exist: true,
      free_trail: false,
      subscription_details: [],
      firstClick: true,
      secondClick: false,
      thirdClick: false,
      fourthClick: false,
      fifthClick: false,
      sixthClick: false,
      threeMonths: true,
      sixMonths: false,
      twelveMonths: false,
      goldPrice: 29999,
      goldDiscountPrice: 19999,
      silverDiscountPrice: '',
      silverPrice: '',
      sku: '1-50',
      category: 'GOLD',
      user_id: this.$store.state.credentials['attributes']['email'],
      val: true,
      duration: '3',
      subscribeButton: true,
      skusPrice: 2000,
      price: 19999,
      discount: 0,
      code: '',
      valid: false,
      notvalid: false,
      expired: false,
    };
  },
  components: {
    PricingCard,
  },
  mounted() {
  },
  methods: {
    click50() {
      this.firstClick = true;
      this.secondClick = false;
      this.thirdClick = false;
      this.fourthClick = false;
      this.fifthClick = false;
      this.sixthClick = false;
      this.sku = '1-50';
    },
    click100() {
      this.firstClick = false;
      this.secondClick = true;
      this.thirdClick = false;
      this.fourthClick = false;
      this.fifthClick = false;
      this.sixthClick = false;
      this.sku = '50-100';
    }, click150() {
      this.firstClick = false;
      this.secondClick = false;
      this.thirdClick = true;
      this.fourthClick = false;
      this.fifthClick = false;
      this.sixthClick = false;
      this.sku = '100-150';
    }, click200() {
      this.firstClick = false;
      this.secondClick = false;
      this.thirdClick = false;
      this.fourthClick = true;
      this.fifthClick = false;
      this.sixthClick = false;
      this.sku = '150-200';
    }, click250() {
      this.firstClick = false;
      this.secondClick = false;
      this.thirdClick = false;
      this.fourthClick = false;
      this.fifthClick = true;
      this.sixthClick = false;
      this.sku = '200-250';
    },
    click250more() {
      this.firstClick = false;
      this.secondClick = false;
      this.thirdClick = false;
      this.fourthClick = false;
      this.fifthClick = false;
      this.sixthClick = true;
      this.sku = '250 +';
    },
    threeMonths1() {
      this.threeMonths = true;
      this.sixMonths = false;
      this.twelveMonths = false;
      this.goldPrice = 29999;
      this.goldDiscountPrice = 19999;
      this.silverDiscountPrice = '';
      this.silverPrice = '';
      this.duration = '3';
      if (this.subscribeButton) {
        this.price = 19999;
      }
      else {
        this.subscribeButton = true;
        this.goldClick()
      }
    },
    sixMonths1() {
      this.sixMonths = true;
      this.threeMonths = false;
      this.twelveMonths = false;
      this.goldPrice = 59999;
      this.goldDiscountPrice = 29999;
      this.silverDiscountPrice = 19999;
      this.silverPrice = 39999;
      this.duration = '6';
      if (this.subscribeButton) {
        this.price = 29999;
      }
      else {
        this.price = 19999;
      }

    },
    twelveMonths1() {
      this.sixMonths = false;
      this.threeMonths = false;
      this.twelveMonths = true;
      this.goldPrice = 120000;
      this.goldDiscountPrice = 49999;
      this.silverDiscountPrice = 33333;
      this.silverPrice = 80000;
      this.duration = '12';
      if (this.subscribeButton) {
        this.price = 49999;
      }
      else {
        this.price = 49999;
      }

    },
    goldClick() {
      this.category = "GOLD";
      this.subscribeButton = true;
      this.price = this.goldDiscountPrice;
      // this.subscribeButton5 = true;
      // this.subscribeButton2 = false;
      // this.subscribeButton3 = false;
      // this.subscribeButton4 = false;
      // this.subscribeButton1 = false;
    },
    // goldClick1(){
    //   this.category="GOLD";
    //   this.duration='6 MONTHS';
    //   this.subscribeButton = true;
    //   this.subscribeButton1 = true;
    //   this.subscribeButton2 = false;
    //   this.subscribeButton3 = false;
    //   this.subscribeButton4 = false;
    //   this.subscribeButton5 = false;

    // },
    // goldClick2(){
    //   this.category="GOLD";
    //   this.duration='12 MONTHS';
    //   this.subscribeButton = true;
    //   this.subscribeButton2 = true;
    //   this.subscribeButton1 = false;
    //   this.subscribeButton3 = false;
    //   this.subscribeButton4 = false;
    //   this.subscribeButton5 = false;
    //   this.price= this.goldDiscountPrice;
    // },
    silverClick() {
      this.category = "SILVER";
      this.subscribeButton = false;
      this.price = this.silverDiscountPrice;
      // this.subscribeButton3 = true;
      // this.subscribeButton1 = false;
      // this.subscribeButton2 = false;
      // this.subscribeButton4 = false;
      // this.subscribeButton5 = false;
    },
    // silverClick1(){
    //   this.category="SILVER";
    //   this.subscribeButton = false;
    //   this.price= this.silverDiscountPrice;
    //   this.subscribeButton4 = true;
    //   this.subscribeButton1 = false;
    //   this.subscribeButton2 = false;
    //   this.subscribeButton3 = false;
    //   this.subscribeButton5 = false;
    // },
    validate() {
      // if(this.code=='DIS20'){
      //   this.discount=20;
      //   this.notvalid = false;
      //   this.valid=true;
      // }
      // else{
      // this.notvalid = true;
      // this.valid=false;
      // }
      console.log(this.code);
      var userURL = this.api_url + `/products/validate_coupon`;
      this.$http
        .post(userURL)
        .then((response) => {
          console.log("coupon", response.data)
          if (response.data == this.code) {
            if (response.data == "DISC20") {
              this.discount = 20;
              this.expired = false;
              this.notvalid = false;
            }
            else if (response.data == "DISC30") {
              this.discount = 30;
              this.expired = false;
              this.notvalid = false;
            }
            else if (response.data == "DISC50") {
              this.discount = 50;
              this.expired = false;
              this.notvalid = false;
            }
            // else if(response.data =="Expired"){
            //   this.discount = 0;
            //   this.expired=true;
            //   this.notvalid=false;
            // }
            else {
              this.notvalid = true;
              this.discount = 0;
              this.expired = false;
            }
          }
          else {
            this.notvalid = true;
            this.discount = 0;
            this.expired = false;
          }
        })
    },
    placeOrder() {
      if (this.val == true) {
        console.log(this.user_id);
        this.$q.loading.show({
          message: 'Validating request please wait..'
        });
        let postURL = this.api_url + `/products/trigger_subscription`;
        this.$http
          .post(postURL, [{ 'pack': this.category, 'price': ((this.price + this.skusPrice) - (this.price + this.skusPrice) * this.discount / 100), 'user_id': this.user_id }])
          .then((response) => {
            console.log("response", response.data)
            if (response.data) {
              this.details = response.data;
              console.log(this.details);
              console.log("done");
              console.log(this.duration);
            }
            let info = {
              'order_id': this.details['order_id'],
              'amount': this.details['amount'],
              'currency': this.details['currency'],
              'user': this.details['user_id'],
              'pack': this.category,
              'price': (this.price + this.skusPrice - this.discount),
              'duration': this.duration,
              'sku': this.sku,
            }
            this.$q.loading.hide();
            // window.location.href = "http://127.0.0.1:6080/razorpay/pay?info=" + JSON.stringify(info);
            window.location.href = "https://api-test-ecs.uniqin.ai/razorpay/pay?info=" + JSON.stringify(info);

          });
      }
      else {
      }
    },
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");

body {
  font-family: "Montserrat", sans-serif;
}

.whole {
  height: 770px;
  /* UI Properties */
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000059;
  border-radius: 20px;
  padding: 28px 44px;
  margin: 32px 12px 12px 12px;
  border-radius: 20px;
  opacity: 1;
}

.title {
  text-align: center;
  font: normal normal 600 30px/49px Montserrat;
  letter-spacing: 0px;
  color: #171717;
  text-transform: capitalize;
  opacity: 1;
}

.subtitle {
  font: normal normal 600 25px/49px Montserrat;
  letter-spacing: 0px;
  color: #171717;
  text-transform: capitalize;
  opacity: 1;
}

.white {
  border: 1px dashed #979797;
  color: black;
  background-color: #FFFFFF;
}

.blue {
  background: #102689 0% 0% no-repeat padding-box;
  opacity: 1;
  color: white;
  font-weight: bold;
}

#button1 {
  border-radius: 12px;
  opacity: 1;
  width: 80px;
  height: 27px;
  margin-right: 20px;
  margin-top: 15px;
  font: normal normal medium 16px/19px Montserrat;
  letter-spacing: 0px;
  opacity: 0.9;
}

#button2 {
  width: 90px;
  height: 39px;
  margin-right: 20px;
  border-radius: 17.5px;
}

.rectangle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: inset 2px -2px 6px #00000029, 0px 3px 6px #B2B2B2BF;
  border-radius: 15px;
  opacity: 1;
  margin-top: 30px;
  width: 359px;
  height: 530px;
}

.rectangle2 {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: inset 2px -2px 6px #00000029, 0px 3px 6px #B2B2B2BF;
  border-radius: 15px;
  opacity: 1;
  margin-top: 30px;
  width: 359px;
  height: 530px;
}

.rectangle:hover {
  box-shadow: 0px 3px 6px #102689;
}

.box-title {
  font: normal normal 600 21px/26px Montserrat;
  letter-spacing: 0.44px;
  color: #000000;
  text-transform: uppercase;
  opacity: 1;
}

.discount-price {
  padding-left: 130px;
  font: normal normal medium 26px/44px Montserrat;
  letter-spacing: 0.55px;
  color: #000000;
  opacity: 1;
}

.real-price {
  text-decoration: line-through;
  font: normal normal medium 17px/19px Montserrat;
  letter-spacing: 0.36px;
  color: #000000;
  opacity: 1;
}

.line {
  font-family: 'Plain-Regular', sans-serif;
  color: grey !important;
  opacity: 0.7 !important;
  margin-top: -30px;

}

.line1 {
  font-family: 'Plain-Regular', sans-serif;
  color: grey !important;
  justify-content: center;
  display: flex;

}

.list {
  text-align: left;
  font: normal normal medium 17px/35px Montserrat;
  letter-spacing: 0px;
  color: #6B6B6B;
  opacity: 1;
  margin-right: 10px;
}

.list li {
  margin-bottom: 1px;
}

ul.list li {
  list-style-type: none;
  padding: 0.3em 0 0 2em;
  position: relative;
  font-size: 15px;
}

ul.list li::before {
  content: '✓';
  color: #007DFF;
  font-weight: 600;
  height: 0;
  width: 0;
  position: absolute;
  left: 0.1em;

}

.list1 {
  text-align: left;
  font: normal normal medium 17px/35px Montserrat;
  letter-spacing: 0px;
  color: #6B6B6B;
  opacity: 1;
  margin-right: 10px;
}

.list1 li {
  margin-bottom: 1px;
}

ul.list1 li {
  list-style-type: none;
  padding: 0.3em 0 0 2em;
  position: relative;
  font-size: 15px;
}

ul.list1 li::before {
  content: 'x';
  color: red;
  font-weight: 600;
  height: 0;
  width: 0;
  position: absolute;
  left: 0.1em;

}

.subscribe-silver {
  width: 117px;
  height: 34px;
  /* UI Properties */
  border: 1px solid #707070;
  margin-left: -25px;
  opacity: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font: normal normal 600 16px/23px Montserrat;
  letter-spacing: 0px;
  margin-top: 13px;
  opacity: 1;
  border-radius: 30px;
}

.subscribe-silver1 {
  width: 117px;
  height: 34px;
  margin-top: 3px;
  border: 1px solid #707070;
  opacity: 0.3;
  pointer-events: none;
  font: normal normal 550 16px/23px Montserrat;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 30px;
}

.subscribe-gold {
  width: 117px;
  height: 34px;
  /* UI Properties */
  border: 1px solid #707070;
  margin-left: -25px;
  opacity: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font: normal normal 600 16px/23px Montserrat;
  letter-spacing: 0px;
  opacity: 1;
  border-radius: 30px;
}

.subscribebutton {
  background: #102689 0% 0% no-repeat padding-box;
  color: #FFFFFF;
}

.rectangleclick {
  box-shadow: 0px 3px 6px #102689;
}

.rectanglenotclick {
  box-shadow: inset 2px -2px 6px #00000029, 0px 3px 6px #B2B2B2BF;
}

.notsubscribebutton {
  border: 1px solid #707070;
}

.subscribe-gold:hover,
.subscribe-silver:hover {
  background: #102689 0% 0% no-repeat padding-box;
  color: #FFFFFF;
}

.button-sub {
  justify-content: center;
  display: flex;
}

.box {
  margin-top: 30px;
}

.coupon {
  padding-right: 24px;
  padding-left: 24px;
}

.coupon label {
  color: #2166B1;
}

.validate {
  background-color: #102689;
  color: white;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 30px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 0px 8px 8px 0px;
}

.coupon_input {
  margin-top: 10px;
}

.coupon_input input {
  height: 30px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid #707070;
  padding: 0px 10px;
}

.place-order {
  width: 100%;
  background: #102689 0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  text-align: center;
  font: normal normal bold 17px/20px Montserrat;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  height: 33px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 14px;
}

.your-order {
  text-align: left;
  font: normal normal bold 21px/31px Poppins;
  letter-spacing: 0.97px;
  color: #102689;
  opacity: 1;
}

.product-total {
  text-align: left;
  font: normal normal bold 14px/16px Montserrat;
  letter-spacing: 0px;
  color: #393E46;
  opacity: 1;
}

.data {
  text-align: left;
  font: normal normal medium 14px/17px Montserrat;
  letter-spacing: 0px;
  color: #393E46;
  opacity: 1;
}

.terms {
  text-align: left;
  font: normal normal medium 12px/12px Montserrat;
  color: green;
  letter-spacing: 0px;
  color: #393E46;
  opacity: 1;
}

.q-checkbox__inner {
  font-size: 10px !important;
  width: 10px !important;
  min-width: 0px !important;
  height: 10px !important;
}

.unavailable {
  height: 305px;
  align-items: center;
  justify-content: center;
  display: flex;
  text-align: center;
  font: normal normal medium 17px/29px Montserrat;
  letter-spacing: 0px;
  color: #6B6B6B;
  opacity: 1;
}

.point {
  text-decoration: line-through;
}

.tick {
  color: green;
  font-weight: bold;
  height: 22px;
  margin-top: 4px;
  margin-left: 2px;
}

.privacy {
  text-decoration: underline;
  color: black;
}</style>